"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = exports.StyledButton = exports.Label = void 0;
const Button_1 = __importDefault(require("@mui/material/Button"));
const styles_1 = require("@mui/material/styles");
exports.Label = (0, styles_1.styled)("span")({
    display: "flex",
});
exports.StyledButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
    "&:disabled": {
        color: theme.palette.grayScale.gray4,
    },
}));
const spin = (0, styles_1.keyframes) `
  0% { 
    transform: rotate(0deg); 
  }
  100% { 
    transform: rotate(360deg); 
  }
`;
exports.Loading = (0, styles_1.styled)("div")({
    border: "6px solid #f3f3f3",
    borderRadius: "50%",
    borderTop: "6px solid #3498db",
    width: "6px",
    height: "6px",
    animation: `${spin} 2s linear infinite`,
    marginLeft: ".5rem",
    marginBottom: "1px",
});
